import { Checkbox } from "@mantine/core";
import { useCallback } from "react";
import { type CaseFilters } from "../../services";

interface AdditionalStainFilterProps {
  filters: CaseFilters;
  onFiltersChange: (filters: CaseFilters) => void;
}

export default function AdditionalStainFilter({
  filters,
  onFiltersChange,
}: AdditionalStainFilterProps) {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onFiltersChange({
        ...filters,
        isAdditionalStain: event.currentTarget.checked ? true : undefined,
      });
    },
    [filters, onFiltersChange]
  );

  return (
    <Checkbox
      label="Additional Stains"
      checked={filters.isAdditionalStain || false}
      onChange={handleChange}
    />
  );
}
